import React from "react";
import EntryList from "../EntryList";
import { menuStyle } from "./style.js";

const PopUpMenu = ({ entries, top, left }) => {
  return (
    <EntryList
      entries={entries}
      rowHeight={20}
      containerStyle={{
        ...menuStyle.container,
        top,
        left,
      }}
      entryStyle={menuStyle.option}
    />
  );
};

export default PopUpMenu;
